import line from './line.vue'

export default line
